import React, { useEffect, useState } from "react";
import "./style.css";
import {  useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Form, Modal, Pagination } from "react-bootstrap";
import PaymentRequestsTableRow from "./PaymentRequestsTableRow";
import AxiosController from "../../../authentication/AxiosController";
import Loader from "../../../loader/Loader";
import { Button } from "react-bootstrap";
import { Helmet } from "react-helmet";

const Offer = () => {
  const { slug, lang, id } = useParams();
  const [_] = useTranslation("global");
  const token = localStorage.getItem("token");
  const [loading, handleLoader] = useState(false);
  const [data, setData] = useState([]);
  const [errors, setErrors] = useState({});
  const [show, setShow] = useState(false);
  const [code, setCode] = useState("");
  const [price, setPrice] = useState(null);
  const [price2, setPrice2] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const role = localStorage.getItem("role");

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const get_offers = () => {
    AxiosController.get(`apiv2/${slug}/${lang}/offers/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => {
        handleLoader(false);
        setData(res.data);
      })
      .catch((e) => {});
  };

  const handleSubmit = async (e) => {
    handleLoader(true);
    e.preventDefault();
    const formData = new FormData();
    formData.append("product_id", code);
    formData.append("sys_modified_commission", price);
    formData.append("seller_modified_commission", price2 ?? 0);
    formData.append("offer_id", id);
    formData.append("quantity", quantity);
    AxiosController.post(
      `apiv2/${slug}/${lang}/offers/create-offer-product/`,
      formData,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    )
      .then((res) => {
        handleLoader(false);
        get_offers();
        handleClose();
        setErrors({});
      })
      .catch((e) => {
        handleLoader(false);
        setErrors(e.response.data);

      });
  };
  useEffect(() => {
    handleLoader(true);
    get_offers();
  }, [token, slug, lang, handleLoader]);
  return (
    <div
      className="d-flex flex-column flex-lg-column my-2 gap-3 position-relative"
      style={{ width: "100%" }}
    >
      <Helmet>
        <title>{_("panel.offers2")}</title>
      </Helmet>
      <Loader active={loading} />

      <div
        className="tables-container d-flex flex-column px-2"
        style={{ position: "relative", flexGrow: 3 }}
      >
        <div
          className={`header d-flex ${
            lang === "en" ? "flex-row" : "flex-row"
          } gap-3 align-items-center justify-content-between`}
        >
          <h3 className="fs-1" style={{ color: "rgba(89, 198, 201, 1)" }}>
            {_("panel.offerProducts")} {data[0]?.title}
          </h3>
          {role == 'admin' ? (<Button
            variant="primary"
            onClick={handleShow}
            style={{ background: "#59C6C9", color: "white", border: "none" }}
          >
            {_("panel.add")}
          </Button>) : ''}
        </div>
        {/* Data */}
        <div className="footer d-flex flex-column flex-grow-1">
          {data ? (
            <PaymentRequestsTableRow
              payments_list={data[0]?.products ?? []}
              handleLoader={data?.title}
            />
          ) : (
            ""
          )}
        </div>
      </div>
      {/* Modal */}
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{_("panel.offers2")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>{_("panel.productcode")}</Form.Label>
              <Form.Control
                type="text"
                value={code}
                onChange={(e) => setCode(e.target.value)}
                required
              />
              {errors?.product_id ? (
                <div class="alert alert-danger mt-1" role="alert">
                  {errors?.product_id[0]}
                </div>
              ) : (
                ""
              )}
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>{_("panel.sysCommission")}</Form.Label>
              <Form.Control
                type="text"
                value={price}
                onChange={(e) => setPrice(e.target.value)}
                required
              />
              {errors?.sys_modified_commission ? (
                <div class="alert alert-danger mt-1" role="alert">
                  {errors?.sys_modified_commission[0]}
                </div>
              ) : (
                ""
              )}
            </Form.Group>

            
            <Form.Group className="mb-3">
              <Form.Label>{_("panel.sellerCommission")}</Form.Label>
              <Form.Control
                type="text"
                value={price2}
                onChange={(e) => setPrice2(e.target.value)}
                required
              />
              {errors?.seller_modified_commission ? (
                <div class="alert alert-danger mt-1" role="alert">
                  {errors?.seller_modified_commission[0]}
                </div>
              ) : (
                ""
              )}
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>{_("panel.quantity")}</Form.Label>
              <Form.Control
                type="text"
                value={quantity}
                onChange={(e) => setQuantity(e.target.value)}
                required
              />
              {errors?.quantity ? (
                <div class="alert alert-danger mt-1" role="alert">
                  {errors?.quantity[0]}
                </div>
              ) : (
                ""
              )}
            </Form.Group>

          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            {_("panel.close")}
          </Button>
          <Button onClick={handleSubmit}>{_("panel.save")}</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Offer;
